




















































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IClient } from "@/models/clients";
import i18n from "@/i18n";
import { IContractProduct } from "@/models/contracts";
import CProdMixin from "@/mixins/cProdMixin";
import Context from "@/mixins/context";
import _ from "@/boot/lodash";
import { IRoute } from "@/models/routes";

@Component({
  components: {
    "cprod-image": () =>
      import("@/components/app/global/contractProducts/cProdImage.vue"),
    "cprod-tags": () =>
      import("@/components/app/global/contractProducts/cProdTags.vue")
  }
})
export default class CProdGridItem extends Mixins(Context, CProdMixin) {
  // Props

  @Prop({ default: undefined })
  public readonly cProd!: IContractProduct;

  @Prop({ default: null })
  public readonly clientId!: IClient["id"];

  @Prop({ default: false })
  public readonly isLoading!: boolean;

  @Prop({ default: false })
  public readonly showSkeletons!: boolean;

  @Prop({ default: i18n.t("_action.manage_product") })
  public readonly action!: boolean;

  @Prop({ default: true })
  public redirect!: boolean;

  // Methods

  public get cProdClient() {
    return this.cProd?.clients?.[0];
  }

  public get cProdRoute() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/route`](
      this.cProd
    )?.to as IRoute["to"];
  }

  public get cProdProvisioningRoute() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/routeToProvisioning`
    ](this.cProd)?.to as IRoute["to"];
  }

  public get cProdSetupRoute() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/routeToSetup`
    ](this.cProd)?.to as IRoute["to"];
  }

  public get isAwaitingSetup() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/isAwaitingSetup`
    ](this.cProd);
  }

  public get cProdCondition() {
    return this.getCondition(this.cProd);
  }

  public get iconBindings() {
    // Awaiting Setup
    if (this.isAwaitingSetup)
      return {
        icon: "asterisk",
        iconLabel: this.$t("_sentence.cprod.is_pending_setup_tooltip"),
        iconRouterLink: this.cProdSetupRoute,
        iconType: "is-warning",
        multilined: false
      };
    // Unresolved Provision Request(s)
    const request = _.first(this.cProd?.unresolved_provision_requests);
    if (_.isObject(request))
      return {
        icon: "exclamation-triangle",
        iconLabel: [request.function_name, request.result_message].join(": "),
        iconRouterLink: this.cProdProvisioningRoute,
        iconType: "is-danger"
      };
    // Default (Nothing)
    return {};
  }
}
